import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import ClaimCghs from "../../../../components/patient/Claim/CGHS/ClaimCghs";
import { Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { IDocumentFields } from "../../../../interfaces/ICase";
import {
  deleteUploadedDocument,
  downloadDocument,
  fetchEnhancementProcedure,
  getAllStarhealthDocumentsData,
  getRequiredDocumentsByMaster,
  submitApproval,
  submitApprovalCghsNew,
  updateAllDocumentsData,
} from "../../../../apis/patientService";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import { fetchStepperData } from "../../../../models/preAuthSlice";
import dayjs from "dayjs";
import DocumentDeficiencyModal from "../../../../components/patient/DocumentDeficiencyModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import {
  fetchEnhancementProcedureCghsNew,
  getPreAuthClaimCghsNew,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import {
  fetchProcedureNew,
  intimateClaimSubmissionCghsNew,
  submitClaimSubmissionCghsNew,
  submitClaimSubmissionToEdgeProCghsNew,
} from "../../../../models/preAuthClaimSlice";
import ConfirmSubmissionModalStage from "../../../../components/modals/ConfirmSubmissionModalStage";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import BillAmountConfirmationModal from "./BillAmountConfirmationModal";
import {
  BillItemChecklistEntry,
  ClaimExtraDocument,
} from "../../../../components/modals/BillRequiredDocumentModal";
import SupportingDocumentChecklistModal from "../../../../components/modals/SupportingDocumentChecklistModal";
import SupportingDocumentViewerModal from "../../../../components/modals/SupportingDocumentViewerModal";
import { Table } from "antd";
import ClaimCghsNew from "../../../../components/patient/Claim/CGHS/ClaimCghsNew";
import { GovtBillFetchRequest } from "../../../../models/billsSlice";
import { getGovtBillList } from "../../../../apis/govtBillingService";
import { API_URL } from "../../../../utils/constants";
import { errorMessageModal } from "../../../../utils/modalMessage";

type ClaimCghsNewContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

export interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
  isBillRequiredDocument?: boolean;
  itemNames?: string[];
  itemNameEntries?: BillItemChecklistEntry[];
  required?: boolean;
  multiple?: boolean;
  documentList?: any[];
  data?: string | null;
}

type ApiClaimExtraDocument = {
  id?: string;
  label?: string;
  labelId?: string | number;
  multiple?: boolean;
  data?: string | null;
  documentList?: Array<{
    documentType?: string;
    documentName?: string;
    documentUrl?: string;
    id?: number;
    documentLabelType?: string;
    itemNames?: BillItemChecklistEntry[];
  }>;
  itemNames?: BillItemChecklistEntry[];
};

export type { ClaimExtraDocument };

type BillRequiredDocumentApi = {
  id: number;
  documentName: string;
  itemName: string[];
};

const ClaimCghsNewContainer: FC<ClaimCghsNewContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount,
}) => {
  const [form] = Form.useForm();
  const { patients, auth, enhancement, preAuth } = useSelector(
    (state: RootState) => state,
  );
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const dispatch = useDispatch<AppDispatch>();
  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [billSummaryDocument, setBillSummaryDocument] = useState<any>(null);
  const [auditReportDocument, setAuditReportDocument] = useState<any>(null);
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<{
    requestedDocuments: Document[];
    responseDocuments: Document[];
  }>({
    requestedDocuments: [],
    responseDocuments: [],
  });
  const [caseClaimId, setCaseClaimId] = useState<any>();
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [claimData, setClaimData] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false); //for submit on portal
  const [isSaving, setIsSaving] = useState<boolean>(false); //for saving and updating as draft
  const [isIntimating, setIsIntimating] = useState<boolean>(false);
  const [portalSubmission, setPortalSubmission] = useState(false);
  const [cghsProcedures, setCghsProcedures] = useState<any>([]);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [totalAmount, setTotalAmount] = useState<any>(0);
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);
  const [claimExtraDocuments, setClaimExtraDocuments] = useState<
    ClaimExtraDocument[]
  >([]);
  const [billRequiredDocuments, setBillRequiredDocuments] = useState<Document[]>(
    [],
  );
  const [supportingChecklistModalVisible, setSupportingChecklistModalVisible] =
    useState<boolean>(false);
  const [billRequiredUploadContext, setBillRequiredUploadContext] = useState<{
    doc: Document;
    checkedItems: BillItemChecklistEntry[];
  } | null>(null);
  const [billRequiredPreviewVisible, setBillRequiredPreviewVisible] =
    useState(false);
  const [billRequiredPreviewFile, setBillRequiredPreviewFile] = useState<{
    url: string;
    name: string;
    file: File | null;
  }>({
    url: "",
    name: "",
    file: null,
  });
  const [billRequiredUploading, setBillRequiredUploading] =
    useState<boolean>(false);
  const [supportingPreviewOpen, setSupportingPreviewOpen] =
    useState<boolean>(false);
  const [supportingClickedActiveTab, setSupportingClickedActiveTab] =
    useState<string>();
  const [supportingClickedActiveDocumentUrl, setSupportingClickedActiveDocumentUrl] =
    useState<string>();

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0])),
  );

  const [isErrorState, setIsErrorState] = useState<boolean>(false);
  const lastErrorMessageRef = useRef<string | null>(null);

  useEffect(() => {
    if (isClaimTabActive()) {
      lastErrorMessageRef.current = null;
    }
  }, [activeKey]);

  useEffect(() => {
    if (claimData) {
      setPortalSubmission(claimData?.submitted);
    }
  }, [claimData]);

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  const isClaimTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId,
    );

    setIsErrorState(currentStage?.state?.toLowerCase() === "error");

    return currentStage?.visitStage?.toUpperCase() === "CLAIM";
  };

  useEffect(() => {
    if (cghsProcedures && cghsProcedures?.length > 0) {
      const total = cghsProcedures?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.specialityType?.toLowerCase()?.includes("s")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      // Update the state with the calculated total amount
      setTotalAmount(total);
      // dispatch(cghsAction.totalAmountOfProcedures(total));
    }
  }, [cghsProcedures]);

  useEffect(() => {
    if (
      isErrorState &&
      claimData?.caseClaimInitiateError &&
      claimData?.caseClaimInitiateError !== lastErrorMessageRef.current &&
      isClaimTabActive()
    ) {
      errorMessageModal(claimData?.caseClaimInitiateError);
      lastErrorMessageRef.current = claimData?.caseClaimInitiateError;
    }
  }, [claimData, isErrorState, activeKey]);

  // useEffect(() => {
  //   if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
  //     if (
  //       patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
  //       patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
  //       patients?.fetchBasicDetails?.casesResponse?.healthCareId
  //     ) {
  //       dispatch(
  //         fetchProcedureNew({
  //           caseId: patients?.fetchBasicDetails?.casesResponse?.id,
  //           hospitalId:
  //             patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //           isCghs:
  //             patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //             "CGHS NEW"
  //               ? true
  //               : false,
  //           procedureType:
  //             patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
  //               ? "OP"
  //               : "IP",
  //           schemeId:
  //             patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  //           benType: patients?.fetchBasicDetails?.patientResponse?.cardCategory
  //             ? patients?.fetchBasicDetails?.patientResponse?.cardCategory
  //                 ?.toLowerCase()
  //                 ?.includes("Gen"?.toLowerCase())
  //               ? "DGW"
  //               : patients?.fetchBasicDetails?.patientResponse?.cardCategory
  //                     ?.toLowerCase()
  //                     ?.includes("Private"?.toLowerCase())
  //                 ? "DPW"
  //                 : "DSPW"
  //             : null,
  //         }),
  //       );
  //     }
  //   }
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //   patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
  // ]);

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
  const handlefetchProcedureNewList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedureCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        );
        setCghsProcedures(res);
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isClaimTabActive()) {
      handlefetchProcedureNewList();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );
    }
    getClaimData();
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);

  // const handleFileChange = (documentType: string, isMultiple: boolean) => (e: any) => {
  //   const maxSize = 15 * 1024 * 1024;

  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   if (e?.file) {
  //     setSelectedFile({ file: e.file, documentType: documentType });
  //     setPreviewFile({
  //       url: URL.createObjectURL(e.file),
  //       name: e.file.name,
  //       showUpload: true,
  //       documentType: documentType,
  //     });
  //     setPreviewModalVisible(true);
  //   }
  //   return e?.target?.files;
  // };

  const fetchGovtBills = async () => {
    try {
      if (
        !patients?.fetchBasicDetails?.casesResponse?.healthCareId ||
        !patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId
      )
        return;
      const response = await dispatch(
        GovtBillFetchRequest({
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          govtBillMappingId:
            patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId,
        }),
      );
      // setBillSummaryLink(
      //   response?.payload?.data?.billHeaderResponse?.billSummaryLink
      //     ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billSummaryLink}`
      //     : null,
      // );
      if (response?.payload?.data?.billHeaderResponse?.billSummaryLink) {
        const documentTypeBillSummary = documentTypes?.find(
          (doc) => doc?.label?.toUpperCase() === "BILL SUMMARY",
        );

        const billSummary = {
          id: null,
          documentName: "BILL SUMMARY",
          documentType: documentTypeBillSummary?.labelId
            ? documentTypeBillSummary?.labelId?.toString()
            : "3070",
          documentUrl: response?.payload?.data?.billHeaderResponse
            ?.billSummaryLink
            ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billSummaryLink}`
            : "",
          documentLabelType: "BILL SUMMARY",
          deficiencyCheckStatus: null,
          referenceType: null,
          remarks: null,
        };
        setBillSummaryDocument(billSummary);
      }

      if (response?.payload?.data?.billHeaderResponse?.billAuditReportLink) {
        const documentTypeAuditReport = documentTypes?.find(
          (doc) => doc?.label?.toUpperCase() === "AUDIT REPORT",
        );

        const auditReport = {
          id: null,
          documentName: "AUDIT REPORT",
          documentType: documentTypeAuditReport?.labelId
            ? documentTypeAuditReport?.labelId?.toString()
            : "3082",
          documentUrl: response?.payload?.data?.billHeaderResponse
            ?.billAuditReportLink
            ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billAuditReportLink}`
            : "",
          documentLabelType: "AUDIT REPORT",
          deficiencyCheckStatus: null,
          referenceType: null,
          remarks: null,
        };
        setAuditReportDocument(auditReport);
      }
    } catch (error) {
      console.error("Error in fetching bill:", error);
    }
  };

  useEffect(() => {
    fetchGovtBills();
  }, [patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId]);

  const getBillRequiredDocumentLabels = (): string[] =>
    billRequiredDocuments
      ?.map((doc) => doc?.label?.toUpperCase())
      ?.filter(Boolean) as string[];

  const isBillRequiredDocumentLabel = (label?: string) =>
    getBillRequiredDocumentLabels()?.includes(label?.toUpperCase() || "");

  const excludeBillRequiredFromClaimAttachments = (docs: any[] = []) =>
    docs?.filter(
      (doc) => !isBillRequiredDocumentLabel(doc?.documentLabelType),
    ) || [];

  const getRegularClaimDocuments = () =>
    documentUrls?.filter(
      (doc) =>
        !["BILL SUMMARY", "AUDIT REPORT"].includes(
          doc?.documentLabelType?.toUpperCase(),
        ) && !isBillRequiredDocumentLabel(doc?.documentLabelType),
    ) || [];

  const mapBillApiToDocuments = (
    billDocuments: BillRequiredDocumentApi[],
    allDocumentTypes: Document[],
  ): Document[] =>
    billDocuments?.map((billDoc) => {
      const schemeDoc = allDocumentTypes?.find(
        (doc) =>
          doc?.label?.toUpperCase() === billDoc?.documentName?.toUpperCase(),
      );
      return {
        id: billDoc?.id,
        label: billDoc?.documentName,
        labelId: schemeDoc?.labelId ?? billDoc?.id,
        documentName: billDoc?.documentName,
        requestDocument: true,
        required: true,
        isBillRequiredDocument: true,
        itemNames: billDoc?.itemName || [],
      };
    }) || [];

  const mergeClaimExtraUploadsIntoBillDocuments = (
    billDocs: Document[],
    apiClaimExtraDocs: ApiClaimExtraDocument[] = [],
  ): Document[] =>
    billDocs.map((doc) => {
      const extraDoc = apiClaimExtraDocs.find(
        (entry) =>
          entry?.label?.toUpperCase() === doc?.label?.toUpperCase(),
      );
      if (!extraDoc) return doc;
      return {
        ...doc,
        documentList: extraDoc?.documentList || [],
        data: extraDoc?.data ?? doc.data,
        multiple: extraDoc?.multiple ?? doc.multiple,
        itemNameEntries: extraDoc?.itemNames,
      };
    });

  const mapApiClaimExtraDocumentsToState = (
    apiClaimExtraDocs: ApiClaimExtraDocument[] = [],
    billRequiredDocs: Document[] = [],
  ): ClaimExtraDocument[] => {
    const flat: ClaimExtraDocument[] = [];

    apiClaimExtraDocs.forEach((docType) => {
      const billDoc = billRequiredDocs.find(
        (doc) =>
          doc?.label?.toUpperCase() === docType?.label?.toUpperCase(),
      );

      const resolveItemNames = (
        docItemNames?: BillItemChecklistEntry[],
      ): BillItemChecklistEntry[] => {
        if (docItemNames?.length) return docItemNames;
        if (docType?.itemNames?.length) return docType.itemNames;
        return (
          billDoc?.itemNames?.map((itemName) => ({
            itemName,
            checked: true,
          })) || []
        );
      };

      docType?.documentList?.forEach((doc) => {
        if (!doc?.documentUrl) return;
        flat.push({
          documentId: Number(
            docType?.labelId ?? billDoc?.labelId ?? billDoc?.id ?? 0,
          ),
          documentName: docType?.label || doc?.documentLabelType || "",
          documentType: doc?.documentType || String(docType?.labelId ?? ""),
          documentUrl: doc.documentUrl,
          documentLabelType: doc?.documentLabelType || docType?.label || "",
          id: doc?.id,
          itemNames: resolveItemNames(doc?.itemNames),
        });
      });
    });

    return flat;
  };

  const getUploadedBillExtraDocument = (doc?: Document | null) =>
    claimExtraDocuments?.find(
      (entry) =>
        entry?.documentName?.toUpperCase() === doc?.label?.toUpperCase() ||
        entry?.documentLabelType?.toUpperCase() === doc?.label?.toUpperCase(),
    );

  const resetBillRequiredPreview = () => {
    if (billRequiredPreviewFile.url) {
      URL.revokeObjectURL(billRequiredPreviewFile.url);
    }
    setBillRequiredPreviewVisible(false);
    setBillRequiredUploadContext(null);
    setBillRequiredPreviewFile({ url: "", name: "", file: null });
  };

  const handleBillRequiredFileSelect = (
    doc: Document,
    checkedItems: BillItemChecklistEntry[],
    file: File,
  ) => {
    setBillRequiredUploadContext({ doc, checkedItems });
    setBillRequiredPreviewFile({
      url: URL.createObjectURL(file),
      name: file.name,
      file,
    });
    setBillRequiredPreviewVisible(true);
  };

  const buildUploadFormData = (documentType: string | number, file: File) => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
      );
    }
    CollectPostData.append("documentType", String(documentType));
    CollectPostData.append("file", file);
    return CollectPostData;
  };

  const handleBillRequiredPreviewUpload = async () => {
    if (!billRequiredUploadContext?.doc || !billRequiredPreviewFile.file) return;

    await handleBillRequiredUpload(
      billRequiredPreviewFile.file,
      billRequiredUploadContext.checkedItems,
      billRequiredUploadContext.doc,
    );
  };

  const handleBillRequiredUpload = async (
    file: File,
    checkedItems: BillItemChecklistEntry[],
    doc: Document,
  ) => {
    const selectedItems = checkedItems?.filter((entry) => entry.checked);
    if (!selectedItems?.length) {
      errorMessage("Please select at least one bill item before uploading");
      return;
    }

    try {
      setBillRequiredUploading(true);
      const documentRes = await dispatch(
        UploadDocument({
          formData: buildUploadFormData(doc?.labelId ?? doc?.id, file),
          accessToken: auth.accessToken || "",
        }),
      ).unwrap();

      if (documentRes?.errorMessage) {
        errorMessage(documentRes.errorMessage);
        return;
      }

      const uploadedDocs = (Array.isArray(documentRes)
        ? documentRes
        : [documentRes]
      )?.filter((uploadedDoc: any) => uploadedDoc?.documentUrl);

      if (!uploadedDocs?.length) {
        errorMessage("Failed to upload document");
        return;
      }
      const withoutSameDocument =
        claimExtraDocuments?.filter(
          (entry) =>
            entry?.documentName?.toUpperCase() !== doc?.label?.toUpperCase(),
        ) || [];
      const updatedExtraDocuments = buildUpdatedClaimExtraDocuments(
        uploadedDocs,
        doc,
        checkedItems,
        withoutSameDocument,
      );

      setClaimExtraDocuments(updatedExtraDocuments);
      await handleAttachDocuments([], updatedExtraDocuments);
      message.success(`${doc?.label} uploaded successfully`);
      resetBillRequiredPreview();
    } catch (error) {
      console.error("Failed to upload bill required document:", error);
      errorMessage("Failed to upload document");
    } finally {
      setBillRequiredUploading(false);
    }
  };

  const handleBillRequiredDelete = async (
    doc: Document | null,
    documentUrl?: string,
  ) => {
    const uploadedDocument = documentUrl
      ? claimExtraDocuments?.find((entry) => entry.documentUrl === documentUrl)
      : getUploadedBillExtraDocument(doc);
    if (!uploadedDocument?.documentUrl) return;

    try {
      setBillRequiredUploading(true);
      await deleteUploadedDocument({
        documentUrl: uploadedDocument.documentUrl,
        status: false,
        id: uploadedDocument.id,
      });

      const updatedExtraDocuments =
        claimExtraDocuments?.filter(
          (entry) => entry.documentUrl !== uploadedDocument.documentUrl,
        ) || [];

      setClaimExtraDocuments(updatedExtraDocuments);
      await handleAttachDocuments([], updatedExtraDocuments);
      message.success("Document deleted successfully");
    } catch (error) {
      console.error("Failed to delete bill required document:", error);
      message.error("Please, Try again later");
    } finally {
      setBillRequiredUploading(false);
    }
  };

  const validateBillRequiredDocumentsUploaded = () => {
    if (!billRequiredDocuments?.length) {
      return true;
    }
    return billRequiredDocuments?.every((doc) =>
      claimExtraDocuments?.some(
        (extra) =>
          extra?.documentName?.toUpperCase() === doc?.label?.toUpperCase() ||
          extra?.documentLabelType?.toUpperCase() === doc?.label?.toUpperCase(),
      ),
    );
  };

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  const buildUpdatedClaimExtraDocuments = (
    uploadedDocs: any[],
    requestedDoc: Document,
    checkedItems: BillItemChecklistEntry[],
    existingExtraDocuments: ClaimExtraDocument[] = [],
  ): ClaimExtraDocument[] => {
    const selectedItems =
      checkedItems?.filter((entry) => entry.checked) || [];

    const extraEntries: ClaimExtraDocument[] = uploadedDocs?.map((doc: any) => ({
      documentId: requestedDoc?.id,
      documentName: requestedDoc?.label || requestedDoc?.documentName || "",
      documentType: doc?.documentType,
      documentUrl: doc?.documentUrl,
      documentLabelType: doc?.documentLabelType,
      id: doc?.id,
      itemNames: selectedItems,
    }));

    const uploadedUrls = new Set(extraEntries?.map((entry) => entry.documentUrl));
    const filtered = existingExtraDocuments?.filter(
      (entry) => !uploadedUrls.has(entry.documentUrl),
    );
    return [...filtered, ...extraEntries];
  };

  const fetchDocuments = async () => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId,
        );
        const claimDocumentTypes = AllDocumentList?.["Claim"] || [];
        const apiClaimExtraDocs: ApiClaimExtraDocument[] =
          AllDocumentList?.claimExtraDocuments || [];
        setDocumentTypes(claimDocumentTypes);

        const requestResponseDocuments = {
          requestedDocuments: [] as Document[],
          responseDocuments: [] as Document[],
        };

        claimDocumentTypes?.forEach((document: Document) => {
          if (document?.requestDocument) {
            requestResponseDocuments.requestedDocuments.push(document);
          } else if (document?.responseDocument) {
            requestResponseDocuments.responseDocuments.push(document);
          }
        });

        const billMappingId =
          patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId;
        let mappedBillRequiredDocuments: Document[] = [];
        if (billMappingId) {
          const billRequiredData = await getRequiredDocumentsByMaster(
            caseId,
            visitId,
            billMappingId,
          );
          if (billRequiredData?.documents?.length > 0) {
            mappedBillRequiredDocuments = mapBillApiToDocuments(
              billRequiredData?.documents,
              claimDocumentTypes,
            );
          }
        }

        mappedBillRequiredDocuments = mergeClaimExtraUploadsIntoBillDocuments(
          mappedBillRequiredDocuments,
          apiClaimExtraDocs,
        );
        setBillRequiredDocuments(mappedBillRequiredDocuments);
        setClaimExtraDocuments(
          mapApiClaimExtraDocumentsToState(
            apiClaimExtraDocs,
            mappedBillRequiredDocuments,
          ),
        );

        setDocumentRequestResponseDocuments(requestResponseDocuments);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  const getClaimData = async () => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const res = await getPreAuthClaimCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        );
        if (res && typeof res?.claimSubmissionRes === "object") {
          setClaimData(res?.claimSubmissionRes);
          setCaseClaimId(res?.claimSubmissionRes?.id);
          setIsApproved(res?.claimSubmissionRes?.approved);

          const updatedValues = {
            ...res?.claimSubmissionRes,
            dateOfAdmission:
              res?.claimSubmissionRes?.dateOfAdmission &&
              dayjs(
                res?.claimSubmissionRes?.dateOfAdmission,
                "DD-MM-YYYY HH:mm:ss",
                true,
              ).isValid()
                ? dayjs(
                    res?.claimSubmissionRes?.dateOfAdmission,
                    "DD-MM-YYYY HH:mm:ss",
                  )
                : null,
            dateOfDischarge:
              res?.claimSubmissionRes?.dateOfDischarge &&
              dayjs(
                res?.claimSubmissionRes?.dateOfDischarge,
                "DD-MM-YYYY HH:mm:ss",
                true,
              ).isValid()
                ? dayjs(
                    res?.claimSubmissionRes?.dateOfDischarge,
                    "DD-MM-YYYY HH:mm:ss",
                  )
                : null,
            hospitalBillDate:
              res?.claimSubmissionRes?.hospitalBillDate &&
              dayjs(
                res?.claimSubmissionRes?.hospitalBillDate,
                "DD-MM-YYYY HH:mm:ss",
                true,
              ).isValid()
                ? dayjs(
                    res?.claimSubmissionRes?.hospitalBillDate,
                    "DD-MM-YYYY HH:mm:ss",
                  )
                : null,
            patientDischargeToday:
              res?.claimSubmissionRes?.patientDischargeToday?.toString(),
            patientUtilizedPA:
              res?.claimSubmissionRes?.patientUtilizedPA?.toString(),
            additionalAmountPaid: res?.claimSubmissionRes?.additionalAmountPaid
              ? "true"
              : "false",
            supportingDocument: res?.claimSubmissionRes?.supportingDocument,
            hospitalBillAmount: Math.round(
              Number(
                String(
                  res?.claimSubmissionRes?.hospitalBillAmount || 0,
                ).replace(/,/g, ""),
              ),
            ), //.toLocaleString("en-IN", {maximumFractionDigits: 0,})
          };

          form.setFieldsValue(updatedValues);
        }
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  useEffect(() => {
    if (!isClaimTabActive()) return;

    const fetchData = async () => {
      await getClaimData();
      await fetchDocuments();
    };

    if (activeKey && activeKey?.length > 0) fetchData();
  }, [schemeMetaDataId, activeKey]);

  useEffect(() => {
    const listOfUploadedDocuments = documentTypes?.flatMap(
      (item: any) =>
        item?.documentList?.map((doc: any) => ({
          id: doc?.id,
          documentName: doc?.documentName,
          documentType: doc?.documentType,
          documentUrl: doc?.documentUrl,
          documentLabelType: doc?.documentLabelType,
          deficiencyCheckStatus: doc?.deficiencyCheckStatus,
        })) || [],
    );

    let updatedUrls = listOfUploadedDocuments;
    if (billSummaryDocument) {
      const hasBillSummary = updatedUrls?.some(
        (doc) => doc?.documentLabelType === "BILL SUMMARY",
      );
      if (!hasBillSummary) {
        updatedUrls = [...updatedUrls, billSummaryDocument];
      }
    }

    if (auditReportDocument) {
      const hasAuditReport = updatedUrls?.some(
        (doc) => doc?.documentLabelType === "AUDIT REPORT",
      );
      if (!hasAuditReport) {
        updatedUrls = [...updatedUrls, auditReportDocument];
      }
    }
    setDocumentUrls(updatedUrls);

    // setDocumentUrls(listOfUploadedDocuments);
  }, [documentTypes, billSummaryDocument, auditReportDocument]);

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      await dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  useEffect(() => {
    if (!isClaimTabActive()) return;

    if (activeKey && activeKey?.length > 0) {
      // fetchStepperForStatus();
      // getTimelineDetail();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  const handleOpen = (docType: any, documentUrl: any) => {
    const isBillRequired =
      isBillRequiredDocumentLabel(docType) ||
      claimExtraDocuments?.some(
        (entry) =>
          entry.documentUrl === documentUrl ||
          entry.documentName?.toUpperCase() === docType?.toUpperCase() ||
          entry.documentLabelType?.toUpperCase() === docType?.toUpperCase(),
      );

    if (isBillRequired) {
      setSupportingPreviewOpen(true);
      setSupportingClickedActiveTab(docType);
      setSupportingClickedActiveDocumentUrl(documentUrl);
      return;
    }

    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const supportingDocumentUrls = useMemo(
    () =>
      billRequiredDocuments?.flatMap((doc) => {
        const uploadedDocs =
          (doc?.documentList?.length ?? 0) > 0
            ? doc.documentList ?? []
            : claimExtraDocuments
                ?.filter(
                  (entry) =>
                    entry?.documentName?.toUpperCase() ===
                      doc?.label?.toUpperCase() ||
                    entry?.documentLabelType?.toUpperCase() ===
                      doc?.label?.toUpperCase(),
                )
                .map((entry) => ({
                  documentType: entry.documentType,
                  documentName: entry.documentName,
                  documentUrl: entry.documentUrl,
                  id: entry.id,
                  documentLabelType:
                    entry.documentLabelType || doc.label || "",
                })) || [];

        return uploadedDocs
          ?.filter((entry: any) => entry?.documentUrl)
          .map((entry: any) => ({
            id: entry.id,
            documentName: entry.documentName,
            documentType: entry.documentType,
            documentUrl: entry.documentUrl,
            documentLabelType: entry.documentLabelType || doc.label,
            deficiencyCheckStatus: entry.deficiencyCheckStatus,
          }));
      }) || [],
    [billRequiredDocuments, claimExtraDocuments],
  );

  const handleOpenSupportingDocuments = (
    docType: string,
    documentUrl?: string,
  ) => {
    setSupportingPreviewOpen(true);
    setSupportingClickedActiveTab(docType);
    setSupportingClickedActiveDocumentUrl(documentUrl);
  };

  const handleCancelSupportingPreview = () => {
    setSupportingPreviewOpen(false);
    setSupportingClickedActiveTab(undefined);
    setSupportingClickedActiveDocumentUrl(undefined);
  };

  const handleSupportingDeleteList = async (
    documentType: string,
    documentUrl: string,
  ) => {
    const billDoc =
      billRequiredDocuments?.find(
        (doc) => doc?.label?.toUpperCase() === documentType?.toUpperCase(),
      ) || null;
    await handleBillRequiredDelete(billDoc, documentUrl);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields,
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };

  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes, claimExtraDocuments);
        setSelectedFiles([]);
        setPreviewFiles([]);
        setUploadFileList([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes, claimExtraDocuments);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId),
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl,
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

  const handleApprove = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments?.requestedDocuments,
          documentUrls,
        ) 
        // && validateBillRequiredDocumentsUploaded()
      ) {
        const updatedValues = {
          ...values,
          // additionalAmountPaid: false,
          status: true,
          claimNo: values?.claimNo,
          documents: getRegularClaimDocuments(),
          claimExtraDocuments: claimExtraDocuments,
          // documentUrls?.filter(
          //   (doc) => doc.documentLabelType !== "BILL SUMMARY",
          // ),
          totalAmount: totalAmount?.toString(),
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          hospitalBillDate: values?.hospitalBillDate
            ? dayjs(values?.hospitalBillDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          caseClaimSubmissionId: caseClaimId,
        };
        setIsApprovedInitiated(true);
        const formData = {
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          stage: "Claim",
          approved: true,
          claimRequest: updatedValues,
          caseClaimSubmissionId: caseClaimId,
        };
        const res = await submitApprovalCghsNew(formData);
        setIsApproved(true);
        setIsApprovedInitiated(false);
        message.success("Claim Approved Successfully");
        setConfirmationModal(false);
        await getTimelineDetail();
        await fetchStepperForStatus();
        await getClaimData();
        await fetchDocuments();
        if (visitId) {
          dispatch(
            getBasicDetails({
              id: visitId,
            }),
          );
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setIsApprovedInitiated(false);
        setIsApproved(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      } else {
        errorMessage("Please, Try again later");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      }
      setConfirmationModal(false);
    }
  };

  const handleAttachDocuments = async (
    updatedDocumentUrls: any,
    extraDocuments: ClaimExtraDocument[] = claimExtraDocuments,
  ) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      claimExtraDocuments: ClaimExtraDocument[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      claimExtraDocuments: extraDocuments,
    };

    payloadSchema["caseClaimAttachments"] =
      excludeBillRequiredFromClaimAttachments(updatedDocumentUrls);

    if (caseId && visitId && schemeMetaDataId) {
      try {
        await updateAllDocumentsData(caseId, visitId, payloadSchema);
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      claimExtraDocuments: ClaimExtraDocument[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      claimExtraDocuments: claimExtraDocuments,
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments?.responseDocuments?.some(
        (doc: any) => doc?.label === document?.documentLabelType,
      ),
    );

    payloadSchema["caseClaimAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        await updateAllDocumentsData(caseId, visitId, payloadSchema);
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const isSupportingDocument = Form.useWatch("supportingDocument", form);

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    uploadedDocumentUrls: any,
  ) => {
    if (!mandatoryDocuments?.length) {
      return true;
    }
    for (const doc of mandatoryDocuments) {
      if (
        doc.required ||
        (doc?.label?.toUpperCase() === "SUPPORTING DOCUMENT" &&
          isSupportingDocument === "true")
      ) {
        const isUploaded = uploadedDocumentUrls?.some(
          (uploadedDoc: any) => uploadedDoc?.documentLabelType === doc?.label,
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = {
        ...values,
        // additionalAmountPaid: false,
        status: true,
        claimNo: values?.claimNo,
        documents: getRegularClaimDocuments(),
        claimExtraDocuments: claimExtraDocuments,
        // documentUrls?.filter(
        //   (doc) => doc.documentLabelType !== "BILL SUMMARY",
        // ),
        totalAmount: totalAmount?.toString(),
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        dateOfAdmission: values?.dateOfAdmission
          ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        dateOfDischarge: values?.dateOfDischarge
          ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        hospitalBillDate: values?.hospitalBillDate
          ? dayjs(values?.hospitalBillDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
      };

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
      ) {
        setIsSaving(true);
        const resp = await dispatch(
          submitClaimSubmissionToEdgeProCghsNew({
            data: updatedValues,
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            caseClaimId: caseClaimId,
            // caseClaimId: null,
          }),
        );
        setIsSaving(false);

        if (submitClaimSubmissionToEdgeProCghsNew.fulfilled.match(resp)) {
          successMessage("Claim Saved Successfully");
          setConfirmationModal(false);
          await getClaimData();
          await fetchStepperForStatus();
          await getTimelineDetail();
          await fetchDocuments();
          if (visitId) {
            dispatch(
              getBasicDetails({
                id: visitId,
              }),
            );
          }
        } else if (submitClaimSubmissionToEdgeProCghsNew.rejected.match(resp)) {
          errorMessage("Please, Try again later");
          setConfirmationModal(false);
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsSaving(false);
      setConfirmationModal(false);
    }
  };

  const handleIntimate = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments?.requestedDocuments,
          documentUrls,
        ) 
        // && validateBillRequiredDocumentsUploaded()
      ) {
        const updatedValues = {
          ...values,
          // additionalAmountPaid: false,
          status: true,
          claimNo: values?.claimNo,
          documents: getRegularClaimDocuments(),
          claimExtraDocuments: claimExtraDocuments,
          // documentUrls?.filter(
          //   (doc) => doc.documentLabelType !== "BILL SUMMARY",
          // ),
          totalAmount: totalAmount?.toString(),
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          action: "intimate",
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          hospitalBillDate: values?.hospitalBillDate
            ? dayjs(values?.hospitalBillDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
        };

        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id &&
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
        ) {
          setIsIntimating(true);
          const resp = await dispatch(
            intimateClaimSubmissionCghsNew({
              data: updatedValues,
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId:
                patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataIds?.[0],
              caseClaimId: caseClaimId,
              // caseClaimId: null,
            }),
          );
          setIsIntimating(false);

          if (intimateClaimSubmissionCghsNew.fulfilled.match(resp)) {
            successMessage("Claim Sent To QC Successfully");
            setConfirmationModal(false);
            await getClaimData();
            await fetchStepperForStatus();
            await getTimelineDetail();
            await fetchDocuments();
            if (visitId) {
              dispatch(
                getBasicDetails({
                  id: visitId,
                }),
              );
            }
            setIsIntimating(false);
          } else if (intimateClaimSubmissionCghsNew.rejected.match(resp)) {
            errorMessage("Please, Try again later");
            setIsIntimating(false);
            setConfirmationModal(false);
          }
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsIntimating(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsIntimating(false);
      setConfirmationModal(false);
    }
  };

  const handleSubmitOnPortal = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments?.requestedDocuments,
          documentUrls,
        ) 
        // && validateBillRequiredDocumentsUploaded()
      ) {
        const updatedValues = {
          ...values,
          // additionalAmountPaid: false,
          status: true,
          claimNo: values?.claimNo,
          documents: getRegularClaimDocuments(),
          claimExtraDocuments: claimExtraDocuments,
          totalAmount: totalAmount?.toString(),
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          hospitalBillDate: values?.hospitalBillDate
            ? dayjs(values?.hospitalBillDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };

        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id &&
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
        ) {
          setIsSubmitting(true);
          const resp = await dispatch(
            submitClaimSubmissionCghsNew({
              data: updatedValues,
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId:
                patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataIds?.[0],
              // caseClaimId: null
            }),
          );
          setIsSubmitting(false);
          if (submitClaimSubmissionCghsNew.fulfilled.match(resp)) {
            successMessage("Claim Submitted Successfully");
            setConfirmationModal(false);
            await getClaimData();
            await fetchStepperForStatus();
            await getTimelineDetail();
            await fetchDocuments();
            if (visitId) {
              dispatch(
                getBasicDetails({
                  id: visitId,
                }),
              );
            }
          } else if (submitClaimSubmissionCghsNew.rejected.match(resp)) {
            errorMessage("Please, Try again later");
            setIsSubmitting(false);
            setConfirmationModal(false);
          }
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsSubmitting(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsSubmitting(false);
      setConfirmationModal(false);
    }
  };

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      if (auth?.role?.role !== "FO_STAFF") {
        try {
          await form.validateFields();
        } catch (err: any) {
          if (err?.errorFields) {
            errorMessage("Please, fill all details before submitting");
          } else {
            errorMessage("Please, Try again later");
          }
          return;
        }
      }
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments?.requestedDocuments,
          documentUrls,
        )
      ) {
        errorMessage("Please, Upload all required documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do You want to save Claim ?");
    } else if (confirmationState === "update") {
      setTitle("Do You want to update Claim ?");
    } else if (confirmationState === "submit") {
      setTitle("Do You want to submit Claim ?");
    } else if (confirmationState === "approve") {
      setTitle("Do You want to approve Claim ?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send Claim for QC ?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSubmit();
    } else if (confirmationState === "update") {
      await handleSubmit();
    } else if (confirmationState === "submit") {
      await handleSubmitOnPortal();
    } else if (confirmationState === "approve") {
      await handleApprove();
    } else if (confirmationState === "intimate") {
      await handleIntimate();
    }

    setConfirmationModal(false);
  };

  const totalBillAmount = Form.useWatch("totalBillAmount", form);

  const [totalProcedureAmount, setTotalProcedureAmount] = useState(0);

  useEffect(() => {
    if (cghsProcedures?.length > 0) {
      const total = cghsProcedures?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.specialityType?.toLowerCase()?.includes("s")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);

        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);

      setTotalProcedureAmount(total);
    }
  }, [cghsProcedures]);

  const [isProcedureCondition, setIsProcedureCondition] = useState(false);
  const [isThresholdCondition, setIsThresholdCondition] = useState(false);
  const [amountConfirmationModal, setAmountConfirmationModal] = useState(false);

  useEffect(() => {
    const billAmount = totalBillAmount ? parseFloat(totalBillAmount) : 0;

    if (!totalBillAmount || isNaN(billAmount) || billAmount <= 0) {
      setAmountConfirmationModal(false);
      return;
    }

    const procedureCond =
      billAmount !== totalProcedureAmount && totalProcedureAmount > 0;
    const thresholdCond = billAmount > 3000;

    setIsProcedureCondition(procedureCond);
    setIsThresholdCondition(thresholdCond);

    if (
      (billAmount !== totalProcedureAmount && totalProcedureAmount > 0) ||
      billAmount > 3000
    ) {
      setAmountConfirmationModal(true);
    } else {
      setAmountConfirmationModal(false);
    }
  }, [totalBillAmount, totalProcedureAmount]);

  useEffect(() => {
    if (!form.getFieldValue("totalBillAmount") || !claimData?.totalBillAmount) {
      form.setFieldValue(
        "totalBillAmount",
        totalProcedureAmount?.toString().replace(/,/g, ""),
      );
    }

    if (
      !form.getFieldValue("totalClaimAmount") ||
      !claimData?.totalClaimAmount
    ) {
      form.setFieldValue(
        "totalClaimAmount",
        totalProcedureAmount?.toString().replace(/,/g, ""),
      );
    }
  }, [form, totalProcedureAmount, claimData]);

  const getAmountConditionTable = () => {
    const columns: any[] = [{ dataIndex: "condition", key: "condition" }];
    const data: any[] = [];

    if (isProcedureCondition) {
      data.push({
        key: "procedure",
        "Total Bill Amount": totalBillAmount || 0,
        "Total PreAuth Amount": totalProcedureAmount,
        Note: "Total bill amount is not equal to total preauth amount.",
      });
    }
    if (
      isThresholdCondition &&
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP"
    ) {
      data.push({
        key: "threshold",
        "Total Bill Amount": totalBillAmount || 0,
        Note: "The total bill amount is greater than 3000.",
      });
    }

    const fieldSet = new Set<string>();
    data.forEach((row) =>
      Object.keys(row)?.forEach((field) => fieldSet.add(field)),
    );
    fieldSet.delete("key");
    fieldSet.delete("condition");
    const dynamicColumns = Array.from(fieldSet)?.map((field) => ({
      title: field,
      dataIndex: field,
      key: field,
    }));
    columns.push(...dynamicColumns);

    return (
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
    );
  };

  const [govtBillMappingId, setGovtBillMappingId] = useState<number | null>(
    null,
  );

  const fetchHospitalBillList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        const filters = {
          pageNumber: 1,
          pageSize: 10,
          searchTer: "",
        };
        const response = await getGovtBillList(
          patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          filters,
        );

        setGovtBillMappingId(
          response?.data?.billMappingResponseList?.length
            ? response.data.billMappingResponseList?.[0].id
            : null,
        );
      }
    } catch (err) {}
  };

  const items = Form.useWatch("items", form);

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isClaimTabActive()) {
      fetchHospitalBillList();
    }
  }, [activeKey, patients?.fetchBasicDetails?.casesResponse?.healthCareId]);

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isClaimTabActive() && claimData) {
      fetchGovtBill();
    }
  }, [
    activeKey,
    preAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    claimData,
    govtBillMappingId,
  ]);

  const fetchGovtBill = async () => {
    try {
      if (
        !patients?.fetchBasicDetails?.casesResponse?.healthCareId ||
        !govtBillMappingId
      )
        return;
      const response = await dispatch(
        GovtBillFetchRequest({
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          govtBillMappingId: govtBillMappingId,
        }),
      );
      if (
        !form.getFieldValue("hospitalBillDate") ||
        !claimData?.hospitalBillDate
      ) {
        form.setFieldsValue({
          hospitalBillDate: response?.payload?.data?.billHeaderResponse
            ?.billDateTime
            ? dayjs(
                response?.payload?.data?.billHeaderResponse?.billDateTime,
                "DD/MM/YYYY",
              )
            : null,
        });
      }

      if (
        !form.getFieldValue("hospitalBillNumber") ||
        !claimData?.hospitalBillNumber
      ) {
        form.setFieldsValue({
          hospitalBillNumber: response?.payload?.data?.billHeaderResponse
            ?.billNo
            ? response?.payload?.data?.billHeaderResponse?.billNo
            : null,
        });
      }

      if (
        !form.getFieldValue("hospitalBillAmount") ||
        !claimData?.hospitalBillAmount
      ) {
        form.setFieldsValue({
          hospitalBillAmount: response?.payload?.data?.billHeaderResponse
            ?.grandTotal
            ? Math.round(
                Number(
                  String(
                    response?.payload?.data?.billHeaderResponse?.grandTotal,
                  ).replace(/,/g, ""),
                ),
              )
            : // response?.payload?.data?.billHeaderResponse?.grandTotal?.toString()?.replace(/,/g, "")?.toLocaleString(
              //     "en-IN",
              //     {
              //       minimumFractionDigits: 0,
              //       maximumFractionDigits: 0,
              //     },
              //   )
              null,
        });
      }
    } catch (error) {
      console.error("Error in fetching bill:", error);
    }
  };

  return (
    <div>
      <ClaimCghsNew
        form={form}
        patients={patients?.fetchBasicDetails}
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
        handleSubmit={handleSubmit}
        handleSubmitOnPortal={handleSubmitOnPortal}
        handleApprove={handleApprove}
        isApproved={isApproved}
        isApprovedInitiated={isApprovedInitiated}
        caseClaimId={caseClaimId}
        isSubmitting={isSubmitting}
        isSaving={isSaving}
        isIntimating={isIntimating}
        currentActiveStage={currentActiveStage}
        preAuth={preAuth}
        documentRequestResponseDocuments={documentRequestResponseDocuments}
        handleSaveData={handleSaveData}
        activeKey={activeKey}
        portalSubmission={portalSubmission}
        loading={loading}
        handleSaveConfirmationModal={handleSaveConfirmationModal}
        claimData={claimData}
        cghsProcedures={cghsProcedures}
        uploadFileList={uploadFileList}
        billRequiredDocuments={billRequiredDocuments}
        claimExtraDocuments={claimExtraDocuments}
        onOpenSupportingChecklist={() => setSupportingChecklistModalVisible(true)}
      />

      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={portalSubmission}
        fetchingDeficiencyData={fetchingDeficiencyData}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        isHospitalBillDischargeSummary={true}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
      />

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={isSaving || isApprovedInitiated || isSubmitting}
        // content={
        //   isProcedureCondition || isThresholdCondition
        //     ? getAmountConditionTable()
        //     : null
        // }
        content={null}
      />

      {/* <BillAmountConfirmationModal
        isModalVisible={amountConfirmationModal}
        handleCancel={() => {
          setAmountConfirmationModal(false);
        }}
        handleOk={() => {
          setAmountConfirmationModal(false);
        }}
        text={getAmountConditionTable()}
      /> */}

      <SupportingDocumentChecklistModal
        visible={supportingChecklistModalVisible}
        documents={billRequiredDocuments}
        claimExtraDocuments={claimExtraDocuments}
        portalSubmission={portalSubmission}
        onCancel={() => setSupportingChecklistModalVisible(false)}
        onFileSelect={handleBillRequiredFileSelect}
        onView={(record) => {
          const uploadedDocs =
            record?.documentList?.filter((entry: any) => entry?.documentUrl) ||
            [];
          handleOpenSupportingDocuments(
            record?.label,
            uploadedDocs[0]?.documentUrl,
          );
        }}
      />

      <SupportingDocumentViewerModal
        open={supportingPreviewOpen}
        documents={supportingDocumentUrls}
        clickedActiveTab={supportingClickedActiveTab}
        clickedActiveDocumentUrl={supportingClickedActiveDocumentUrl}
        portalSubmission={portalSubmission}
        onCancel={handleCancelSupportingPreview}
        onDownload={handleDownloadDocument}
        onDelete={handleSupportingDeleteList}
      />

      {billRequiredPreviewFile.file && (
        <FilePreviewModal
          isVisible={billRequiredPreviewVisible}
          onClose={resetBillRequiredPreview}
          fileUrl={billRequiredPreviewFile.url}
          fileName={billRequiredPreviewFile.name}
          documentType={String(
            billRequiredUploadContext?.doc?.labelId ??
              billRequiredUploadContext?.doc?.id ??
              "",
          )}
          handleUpload={handleBillRequiredPreviewUpload}
          showUploadButton
          key={billRequiredPreviewFile.file.lastModified}
          isLoading={billRequiredUploading || enhancement?.isLoading}
        />
      )}

    </div>
  );
};

export default ClaimCghsNewContainer;
